export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-insights@2x.2fac5050cf03e5dbfbce26b71f0abb49.png";